import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import PatientList from "./components/PatientList";
import InvoiceList from "./components/InvoiceList";
import PrescriptionContainer from "./pages/PrescriptionContainer";
import SignIn from "./components/SignIn";
// import SignUp from "./components/SignUp";
import SignUpContainer from "./pages/SignUpContainer";
import ProviderSignup from "./components/ProviderSignup";
import PatientContainer from "./pages/PatientContainer";
import MedicationList from "./components/MedicationList";
import "./styles/App.css";
import HomePage from "./pages/HomePage";
import AdminSignIn from "./pages/AdminPage";
import ClinicContainer from "./pages/ClinicContainer";
import AdminPage from "./pages/AdminPage";
import ClinicList from "./pages/ClinicsPage";
import ProviderContainer from "./pages/ProviderContainer";
import ClinicStripeOnboarding from "./components/ClinicStripeOnboarding";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AllProviders from "./components/AllProviders";
import QuestionnairePage from "./pages/QuestionnairePage";
import QuestionnaireEdit from "./components/QuestionnaireEdit";
import InactivityLogoutModal from "./components/modals/InactivityLogoutModal";
import "@fontsource/outfit";

const App: React.FC = () => {
  /// possible solution " server resonse === "jwt token expired, then remove token item from localstorage""
  const searchParams = new URLSearchParams(window.location.search);
  const message = searchParams.get("message");

  const navigate = useNavigate();
  const [showInactivityModal, setShowInactivityModal] = useState(false);
  const token = localStorage.getItem("token");

  const logout = () => {
    localStorage.clear();
    setShowInactivityModal(false);
    navigate("/");
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (token) {
      const resetTimer = () => {
        clearTimeout(timer);
        timer = setTimeout(() => setShowInactivityModal(true), 20 * 60 * 1000);
      };

      const events = ["mousemove", "keydown", "click", "scroll"];
      events.forEach((event) => window.addEventListener(event, resetTimer));
      resetTimer();

      return () => {
        events.forEach((event) =>
          window.removeEventListener(event, resetTimer)
        );
        clearTimeout(timer);
      };
    }
  }, [token]);

  return (
    <>
      {showInactivityModal && <InactivityLogoutModal onLogout={logout} />}
      <div>
        {message && (
          <h3 style={{ color: "red", textAlign: "center" }}>{message}</h3>
        )}
      </div>
      <ToastContainer position="top-right" autoClose={3000} />

      <Routes>
        <Route path="/all-medications" element={<MedicationList />} />

        <Route path="/" element={<HomePage />} />
        <Route path="/clinic-profile" element={<ClinicContainer />} />
        <Route path="/clinic/:id" element={<ClinicContainer />} />
        <Route path="/provider-profile" element={<ProviderContainer />} />
        <Route
          path="/questionnaires/:id/edit"
          element={<QuestionnaireEdit />}
        />

        {/* <Route
          path="/clinic-account-onboarding"
          element={<ClinicStripeOnboarding />}
        /> */}
        <Route path="/patient-profile/:id" element={<PatientContainer />} />

        <Route path="/patients" element={<PatientList />} />
        <Route path="/questionnaires" element={<QuestionnairePage />} />
        <Route path="/invoices" element={<InvoiceList />} />
        <Route path="/providers" element={<AllProviders />} />

        <Route path="/prescriptions" element={<PrescriptionContainer />} />
        <Route path="/sign-in" element={<SignIn />} />

        <Route path="/signup" element={<SignUpContainer />} />
        {/* <Route path="/signup/clinic" element={<SignUp />} /> */}
        <Route path="/signup/provider" element={<ProviderSignup />} />
        <Route path="/holaholahola" element={<AdminSignIn />} />
        <Route path="/admin/dashboard" element={<AdminPage />} />
        <Route path="/clinics" element={<ClinicList />} />
      </Routes>
    </>
  );
};

export default App;
